import { ConvertedMeasurement } from 'lib/ConvertedMeasurement';
import { ConvertibleMeasurement, NullableConvertibleMeasurement } from 'lib/ConvertibleMeasurement';
import { MeasurementInFeetAndInches } from 'lib/MeasurementInFeetAndInches';
import UOM from 'lib/UOM';

import { MeasurementLike, NullableMeasurementLike } from 'data/models/Measurement';

export interface DecimalPlaces {
    inches? : number;
    meters? : number;
}

export interface FeetInchesMetersEditParams<T> {
    backingMeasurement : T;
    decimalPlaces? : DecimalPlaces
}

export function FeetInchesMetersEdit({
    backingMeasurement,
    decimalPlaces
} : FeetInchesMetersEditParams<MeasurementLike>) {
    let convertible : ConvertibleMeasurement;
    if (backingMeasurement instanceof ConvertibleMeasurement) convertible = backingMeasurement;
    else convertible = new ConvertibleMeasurement(backingMeasurement);

    return makeMeasurements(convertible, decimalPlaces);
}
export type FeetInchesMetersEdit = ReturnType<typeof FeetInchesMetersEdit>;

export function NullableFeetInchesMetersEdit({
    backingMeasurement,
    decimalPlaces
} : FeetInchesMetersEditParams<NullableMeasurementLike>) : FeetInchesMetersEdit {
    let convertible : NullableConvertibleMeasurement;
    if (backingMeasurement instanceof NullableConvertibleMeasurement) convertible = backingMeasurement;
    else convertible = new NullableConvertibleMeasurement(backingMeasurement);

    return makeMeasurements(convertible, decimalPlaces);
}

function makeMeasurements(convertible : NullableConvertibleMeasurement, decimalPlaces? : DecimalPlaces) {
    return {
        FeetAndInches: new MeasurementInFeetAndInches(convertible, (decimalPlaces || {}).inches || 0),
        Meters: new ConvertedMeasurement(convertible, UOM.Meter, (decimalPlaces || {}).meters || 0)
    };
}


// WEBPACK FOOTER //
// ./apps/portcall/feetinchesmetersedit/model.ts